import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Grid } from "@material-ui/core";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { config } from "../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import { InputLabel } from "@material-ui/core";
import "./retailerview.scss";
import Loader from "../../../components/Loader/Loader";
import FileUpload from "../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../components/FileUpload/GlobalDropZone";
import { useUserAuthentication } from "../../../utils/utils";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    setInitial,
    setTableLoading,
    setMappedDataCreateNew,
    updateSourceInputs,
    loading,
    setMappedData,
    isSearchFilterLoading,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isFetchValues, setFetchValues] = useState(false);
  const { login } = useUserAuthentication();
  let history = useHistory();

  const isCreateNewVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Create new" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_source === "" ||
      isSearchFilterLoading == true ||
      isFilterLoading === true
    );
  }, [
    source_data,
    source_data.current_filter_value,
    isSearchFilterLoading,
    isFilterLoading,
  ]);

  const isExistingVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Existing" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_source == "" ||
      isSearchFilterLoading == true ||
      isFilterLoading === true
    );
  }, [
    source_data,
    source_data.current_filter_value,
    isSearchFilterLoading,
    isFilterLoading,
  ]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  const handleSourceChange = async (e, selectedOption) => {
    updateSourceInputs("current_source", selectedOption.value);
    setInitial(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_filter_value", "");
  };

  const handleRadioChange = async (e) => {
    setIsFilterLoading(true);
    setInitial(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_filter_value", e.target.value);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");

    let NEW_COUNTRIES;
    const params = new URLSearchParams({
      dataset_name: "Retailer_mapping",
      source: source_data.current_source || "",
      filtertype: e.target.value === "Existing" ? "existing" : "create" || "",
    });
    try {
      const response = await fetch(
        api + `/retailer_mapping/getcountry?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data && data.data) {
        NEW_COUNTRIES = data?.data || [];
      }

      const countryOptions =
        NEW_COUNTRIES?.filter(
          (country) =>
            country !== null && country !== undefined && country !== ""
        )
          ?.filter((cntry) => cntry != null)
          .map((country) => ({
            label: country,
            value: country,
          })) ?? [];

      updateSourceInputs("current_mapped_country", countryOptions);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }
    setIsFilterLoading(false);
  };

  const handleCountryChange = async (e, selectedOption) => {
    setInitial(true);
    updateSourceInputs("is_initial", true);
    setTableLoading(false);
    updateSourceInputs("is_table_loading", false);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", selectedOption.label);
    updateSourceInputs("current_country_code", selectedOption.value);

    if (source_data.current_filter_value === "Existing") {
      setMappedData(
        source_data.current_source,
        selectedOption.label,
        source_data.current_filter_value
      );
    } else {
      setFetchValues(true);
      let InsertNewTableData;
      const params = new URLSearchParams({
        dataset_name: "New_retailer_mapping",
      });
      try {
        const response = await fetch(
          api + `/retailer_mapping/getmetadata?${params}`,
          {
            method: "GET",
            mode: "cors",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${user.token || ""}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();

        // Check if response is OK before trying to parse it
        if (!response.ok) {
          if (data?.statusCode === "harbor-401") {
            updateAlert({
              open: true,
              message: `User Unauthorized. Please sign in.`,
              severity: "warning",
              closeFlag: true,
            });
            login(); // or redirect to login
            return;
          } else {
            throw new Error(`Unexpected error occured. Please try again later`);
          }
        }

        if (data && data.data) {
          InsertNewTableData = data?.data || {};
        }

        const val = InsertNewTableData.New_retailer_mapping;
        const SAMPLE_DOWNLOAD_FILE =
          val &&
          val.map((item) => {
            let rowData = { ...item };
            Object.keys(rowData).forEach((key) => {
              if (
                rowData[key] === "null" ||
                rowData[key] === undefined ||
                rowData[key] === null
              ) {
                rowData[key] = null;
              }
            });
            const Altered_RowData = rowData;

            if (source_data.current_source === "Nielsen") {
              rowData = {
                ...Altered_RowData,
                COUNTRY: selectedOption.label,
                COUNTRY_CODE: selectedOption.value,
                SOURCE: source_data.current_source,
              };
            } else {
              rowData = {
                ...Altered_RowData,
                COUNTRY: selectedOption.label,
                SOURCE: source_data.current_source,
              };
            }
            return rowData;
          });

        updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);
      } catch (err) {
        updateAlert({
          open: true,
          message: `Unexpected error occured. Please try again later`,
          severity: "Failed ",
          closeFlag: true,
        });
      } finally {
        setFetchValues(false);
      }
    }
  };

  const handlePlaceholderFile = async () => {
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);

    if (source_data.current_filter_value === "Create new") {
      setMappedDataCreateNew(
        source_data.current_country,
        source_data.current_country_code
      );
    }
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <Grid container spacing={4} style={{ padding: "2px 15px 0px 15px" }}>
            {/* DATASET */}
            <Grid item xs={4} sm={4}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Select Dataset:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  id="country-select"
                  disableClearable
                  size="small"
                  options={source_data.current_mapped_source}
                  loading={
                    loading &&
                    (source_data.current_mapped_source ||
                      source_data.current_mapped_source.length === 0)
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleSourceChange}
                  value={
                    source_data.current_source &&
                    source_data.current_source.length > 0
                      ? {
                          label: source_data.current_source,
                          value: source_data.current_source,
                        }
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          source_data.current_source === "" ? "f7f7f7" : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </Grid>

            {/* Filters */}
            <Grid item xs={4} sm={4}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Choose Filter:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div
                className="radio-input-container"
                style={{ marginBottom: "15px" }}
              >
                {/* Insert New */}
                <div className="radio-input-div">
                  <input
                    id="all-checkbox"
                    type="radio"
                    value="Create new"
                    disabled={isCreateNewVisible ? true : false}
                    name="filter"
                    checked={source_data.current_filter_value === "Create new"}
                    onChange={handleRadioChange}
                    className="radio-checkbox-label"
                  />
                  <InputLabel
                    htmlFor={"all-checkbox"}
                    className="radio-checkbox-label"
                  >
                    Create new
                  </InputLabel>
                </div>

                {/* Existing */}
                <div className="radio-input-div">
                  <input
                    id="Unmapped-checkbox"
                    type="radio"
                    value="Existing"
                    disabled={isExistingVisible ? true : false}
                    name="filter"
                    checked={source_data.current_filter_value === "Existing"}
                    onChange={handleRadioChange}
                    className="radio-checkbox-label"
                  />
                  <InputLabel
                    htmlFor={"Unmapped-checkbox"}
                    className="radio-checkbox-label"
                  >
                    Existing
                  </InputLabel>
                </div>
              </div>
            </Grid>

            {/* COUNTRY */}
            {source_data.current_filter_value !== "" &&
              (isFilterLoading ? (
                <Loader />
              ) : (
                <Grid item xs={4} sm={4}>
                  <div
                    className="mg-model-header-item"
                    style={{ height: "25px" }}
                  >
                    Select Country:{" "}
                    <p
                      style={{
                        display: "inline",
                        color: "red",
                        fontSize: 16,
                      }}
                    >
                      *
                    </p>
                  </div>
                  <div className="" style={{ marginBottom: "15px" }}>
                    <Autocomplete
                      disabled={
                        source_data.current_source === "" || loading == true
                          ? true
                          : false
                      }
                      id="country-select"
                      disableClearable
                      size="small"
                      options={source_data.current_mapped_country}
                      getOptionLabel={(option) => option.label}
                      onChange={handleCountryChange}
                      defaultValue={
                        {
                          label: source_data.current_country,
                          value: source_data.current_country_code,
                        } || null
                      }
                      popupIcon={
                        <span
                          className="material-icons"
                          style={{
                            fontSize: "20px",
                            color:
                              source_data.current_source === ""
                                ? "f7f7f7"
                                : "#555",
                          }}
                        >
                          arrow_drop_down
                        </span>
                      }
                      sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#fff",
                          fontFamily: "Hind Siliguri",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: "400",
                          color: "#333",
                          height: "36px",
                          paddingRight: "36px", // space for dropdown icon
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "8px 12px",
                        },
                        "& .MuiAutocomplete-endAdornment": {
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)", // vertical center alignment
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#999",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          // label="Select Country"
                          InputLabelProps={{
                            style: {
                              fontSize: "13px",
                            },
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            color: "#212529",
                          }}
                        >
                          {option.label}
                        </li>
                      )}
                    />
                  </div>
                </Grid>
              ))}
          </Grid>
        </div>
      )}

      {isFetchValues && <Loader />}

      {/* FILE UPLOAD */}
      {!expand &&
        !isFetchValues &&
        Array.isArray(source_data.current_mapped_data) &&
        source_data.current_mapped_data.length === 0 && (
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            {source_data.current_filter_value === "Create new" &&
              source_data.current_country !== "" && (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "15px" }}
                >
                  <div>
                    <GlobalDropZone
                      updateAlert={props.updateAlert}
                      handleFileUpload={props.handleFileUpload}
                      requiredColumns={props.requiredColumns}
                    />
                    <FileUpload
                      updateAlert={props.updateAlert}
                      handleFileUpload={props.handleFileUpload}
                      isFileUploading={props.isFileUploading}
                      requiredColumns={
                        source_data?.data?.dropdown?.download_sample_columns ||
                        []
                      }
                      source_Data={source_data}
                      updateSourceInputs={updateSourceInputs}
                    />
                  </div>
                  <span>Or</span>
                  <button
                    onClick={() => handlePlaceholderFile()}
                    className="sample-button"
                    disabled={source_data.is_table_loading}
                  >
                    Proceed with Existing Template
                  </button>
                </div>
              )}
          </div>
        )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  source_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  source_data: state.source,
  user: state.user,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter)
);
